import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'app-card-layout-content-image',
  template: `
    <div class="p-mt-sm-0 p-mt-6 p-mb-4 p-text-center card-layout-content-image"><ng-content></ng-content></div>
  `,
  styleUrls: ['./card-layout-content-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardLayoutContentImageComponent {
  constructor() {}
}
